module.exports = __webpack_public_path__ + "05a96a21a51c7e8a9a27d9aa592b3b38.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-peg-leg.png
// module id = 2392
// module chunks = 0